import Swiper from 'swiper/swiper-bundle';

export const heroSlider = () => {

	const swiperHero = new Swiper('.js-init-hero-swiper', {
        slidesPerView: "auto",
        autoplay: {
   			delay: 10000,
		},
        loop: true,
        spaceBetween: 32,
        pagination: {
	        el: '.swiper-pagination',
	        type: 'bullets',
	        clickable: true
	    },
    });
}

heroSlider();